import { useState } from "react";
import { FaChevronLeft, FaChevronRight } from "react-icons/fa"; 
import "../../assets/styles/cards.css";
import { MdOutlineMyLocation } from "react-icons/md";

function Price({ route }) {
  const [isOpen, setIsOpen] = useState(true);

  return (
    <div className="price-container">
      {/* Only Arrow */}
      <div className="arrow-header" onClick={() => setIsOpen(!isOpen)}>
        {isOpen ? (
          <>
            <a href={`/listing/${route}`} id="size-a">
              {route
                .replace(/-/g, " ")
                .replace(/\b\w/g, (c) => c.toUpperCase())}
            </a>
            <FaChevronLeft id="size-a" />
          </>
        ) : (
          <FaChevronRight id="size-a" />
        )}
      </div>

      {/* Toggle Content */}
      {isOpen && (
        <div className="section-content">
          {/* Buttons */}
          <div className="main-price-btn">
            <button className="toggle-button active">Open Now</button>
            <button className="toggle-button">Walk-ins OK</button>
          </div>

          {/* Miles from Location */}
          <div className="inner-section">
            <p>MILES FROM LOCATION</p>
            <div className="input-row">
              <input placeholder="miles" />
              <input placeholder="from zip" />
              <MdOutlineMyLocation className="location-icon" />
            </div>

            <a href="/general-veterinary-care">Use map...</a>
          </div>

          {/* Price */}
          <div>
            <p>Price</p>
            <div className="checkbox-line">
              <input type="checkbox" />
              <label>Free</label>
            </div>

            <div className="price-input-row">
              <p>$</p>
              <input placeholder="min" />
              <p>-</p>
              <p>$</p>
              <input placeholder="max" />
            </div>

            <p>Avg: $84</p>
          </div>
        </div>
      )}
    </div>
  );
}

export default Price;
